export default "__VITE_ASSET__59d9438c__"